export enum AccountTypeEnum {
	All = 'All',
	Sml = 'Sml',
	Tr = 'Tr',
}

export default AccountTypeEnum;
